import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=8a278790&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=8a278790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a278790",
  null
  
)

export default component.exports